import { useContext, onMounted, onGlobalSetup, onBeforeUnmount } from '@nuxtjs/composition-api';
import { initializeApp, getApps } from 'firebase/app';
import { signInAnonymously, getAuth } from 'firebase/auth';
import { getToken, isSupported, getMessaging } from 'firebase/messaging';
import { jwtDecode } from '~/modules/common/utils/stringUtils';
import { localStore } from '~/modules/common/utils/localStorageUtils';
import { cookieKey } from '~/modules/common/utils/cookieUtils';
import { eventBus } from '~/modules/common/utils/eventBus';
import { IS_DEV_OR_STAGING, FCM_VALID_KEY } from '~/constants/config';

const firebaseConfig = {
  apiKey: 'AIzaSyBFb6OEU3gNWq-BDiHBbLzRD3YJ1g2h7yM',
  authDomain: 'testonedio.firebaseapp.com',
  databaseURL: 'https://testonedio.firebaseio.com',
  projectId: 'testonedio',
  storageBucket: 'testonedio.appspot.com',
  messagingSenderId: '262942824570',
  appId: '1:262942824570:web:5a81510a441b32028483c3',
  measurementId: 'G-FQVS26J840',
};

export default () => {
  const apps = getApps();
  const app = !apps.length ? initializeApp(firebaseConfig) : apps[0];
  let messaging;

  onGlobalSetup(() => {
    const { $cookies, $oet } = useContext();
    const authenticateFcm = async () => {
      await signInAnonymously(getAuth());
    };

    const requestPermission = async () => {
      try {
        if (Notification.permission !== 'granted') {
          await Notification.requestPermission();
        }
      } catch (e) {
        console.log('Error : ', e); // TODO
      }
    };

    const getIdToken = async ({ force, action } = {}) => {
      try {
        if (Notification.permission !== 'granted') return;
        const userCookie = $cookies.get(cookieKey.AUTH_TOKEN);
        const userId = userCookie && action !== 'logout' ? jwtDecode(userCookie)?.uid : null;
        const idToken = await getToken(messaging, { vapidKey: FCM_VALID_KEY });
        const currentToken = localStore.getItem('o-firebase-fcm');
        if (idToken && (force || currentToken !== idToken)) {
          localStore.setItem('o-firebase-fcm', idToken, { expireMs: 60 * 60 * 24 * 15 }); // 15 days
          if (!IS_DEV_OR_STAGING) {
            await $oet.sendPushNotificationPlatformInformations({
              userId,
              externalPlatform: 'firebase',
              notificationTargetType: 'firebaseToken',
              notificationTargetValue: idToken,
            });
          }
        }
      } catch (e) {
        console.error('Error : ', e); // TODO
      } finally {
        eventBus.emit('fcm-token-sent', action);
      }
    };

    const permissionEventHandler = () => {
      if ('permissions' in navigator) {
        navigator.permissions.query({ name: 'notifications' }).then((notificationPerm) => {
          notificationPerm.onchange = async () => {
            if (notificationPerm.state === 'granted') {
              await authenticateFcm();
              await getIdToken();
            }
          };
        });
      }
    };

    onMounted(async () => {
      const isSupportedFcm = await isSupported();
      const isShowPushAlert = $cookies.get('o-push-alert');
      if ('Notification' in window && isSupportedFcm) {
        messaging = getMessaging(app);
        if (Notification.permission === 'granted') {
          await authenticateFcm();
          await getIdToken();
        } else if (Notification.permission === 'default' && !isShowPushAlert) {
          eventBus.emit('webpush-alert');
        }

        eventBus.on('set-granted', async ({ success }) => {
          if (success) {
            await requestPermission();
          } else {
            const arr = [1, 7, 15];
            let dayIndex;
            const pushAlertDay = localStore.getItem('o-push-alert-day');
            if (pushAlertDay) {
              dayIndex = arr.at(-1) === pushAlertDay ? arr.indexOf(pushAlertDay) : arr.indexOf(pushAlertDay) + 1;
            } else {
              dayIndex = 0;
            }
            localStore.setItem('o-push-alert-day', arr[dayIndex]);
            $cookies.set('o-push-alert', 1, {
              path: '/',
              maxAge: 60 * 60 * 24 * arr[dayIndex],
            });
          }
        });
      }
      eventBus.on('firebase-fcm-user-action', getIdToken);
      permissionEventHandler();
    });

    onBeforeUnmount(() => {
      eventBus.off('firebase-fcm-user-action', getIdToken);
      eventBus.off('set-granted');
    });
  });
};
